import { Link } from "react-router-dom";

const INFO = [
  { icon: "ri-map-pin-line", label: "アクセス", value: "大阪府大阪市XX区\n御堂筋線XX駅 徒歩5分" },
  { icon: "ri-phone-line", label: "電話番号", value: "06-XXXX-XXXX" },
  { icon: "ri-time-line", label: "営業時間", value: "10:00〜20:00（最終受付 19:00）\n定休日：毎週月曜日" },
  { icon: "ri-bank-card-line", label: "お支払い", value: "各種クレジットカード・電子マネー対応" },
];

export default function StoreInfoSection() {
  return (
    <section className="py-24" style={{ backgroundColor: "#3D2E2A" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#C9A86A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            Salon Information
          </p>
          <h4 id="access" className="text-3xl text-white" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
            <a href="#access" className="text-white">店舗情報・アクセス</a>
          </h4>
        </div>

        {/* 2 column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Info */}
          <div>
            <p className="text-[#C9A86A] text-2xl mb-2" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
              ネイルサロン
            </p>
            <h2 className="text-white text-5xl mb-8" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300, letterSpacing: "0.1em" }}>
              BE:NAIL
            </h2>

            <div className="space-y-6">
              {INFO.map(({ icon, label, value }) => (
                <div key={label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#5A4035] shrink-0 mt-0.5">
                    <i className={`${icon} text-[#C9A86A] text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-[#9E8E80] text-xs tracking-wider mb-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{label}</p>
                    <p className="text-white text-sm leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Link
                to="/booking"
                className="inline-flex items-center gap-2 bg-[#B8956A] text-white px-8 py-4 rounded-full text-sm tracking-widest hover:bg-[#A07B55] transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-2-line text-sm" /></span>
                今すぐ予約する
              </Link>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-xl overflow-hidden border border-[#5A4035] h-[400px]">
            <iframe
              title="BE:NAIL アクセスマップ"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.0!2d135.501!3d34.693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQxJzM0LjkiTiAxMzXCsDMwJzAzLjYiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
